import { type IntlShape } from 'react-intl'

import { TENANT } from '../../tenant'

export const directContactFormAccessorGetSubjects = ({
  intl,
  option,
  tenant,
}: {
  intl: IntlShape
  option?: string
  tenant?: TENANT
}): { options: string[]; orderType: boolean } => {
  const isSubjectValidForTenant = tenant
    ? [TENANT.AT, TENANT.BE, TENANT.COM, TENANT.IT].includes(tenant)
    : false

  const orderTypeOptions = [
    intl.formatMessage({ id: 'direct.contact.form.change.order' }),
    intl.formatMessage({ id: 'direct.contact.form.track.delivery.order' }),
    intl.formatMessage({ id: 'direct.contact.form.return.order' }),
    intl.formatMessage({ id: 'direct.contact.form.order.cancellation' }),
    ...(isSubjectValidForTenant
      ? [
          intl.formatMessage({
            id: 'direct.contact.form.order.missing.or.incorrect.item',
          }),
        ]
      : []),
    intl.formatMessage({ id: 'direct.contact.form.report.order' }),
    intl.formatMessage({ id: 'direct.contact.form.payment.reminder' }),
    intl.formatMessage({ id: 'direct.contact.form.missing.invoice' }),
    intl.formatMessage({ id: 'direct.contact.form.defer.payment' }),
    intl.formatMessage({ id: 'direct.contact.form.invoice.status' }),
  ]

  const options = [
    ...orderTypeOptions,
    intl.formatMessage({ id: 'direct.contact.form.change.name' }),
    intl.formatMessage({ id: 'direct.contact.form.change.address' }),
    intl.formatMessage({ id: 'direct.contact.form.advertising' }),
    intl.formatMessage({ id: 'direct.contact.form.delete.account' }),
    intl.formatMessage({ id: 'direct.contact.form.pharma.advice' }),
    intl.formatMessage({ id: 'direct.contact.form.other.concern' }),
  ]

  return {
    options,
    orderType: option ? orderTypeOptions.includes(option) : false,
  }
}
